import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { scales } from "./types";
import { StyledTag } from "./StyledTag";
import { Box } from "@pancakeswap/uikit";
var Tag = function(_param) {
    var startIcon = _param.startIcon, endIcon = _param.endIcon, children = _param.children, props = _object_without_properties(_param, [
        "startIcon",
        "endIcon",
        "children"
    ]);
    var modifiedStartIcon = /*#__PURE__*/ React.isValidElement(startIcon) ? /*#__PURE__*/ _jsxs(Box, {
        style: {
            display: "flex",
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ _jsx(Box, {
                style: {
                    marginRight: "0.5em"
                },
                children: startIcon
            }),
            children
        ]
    }) : children;
    var modifiedEndIcon = /*#__PURE__*/ React.isValidElement(endIcon) ? /*#__PURE__*/ _jsxs(Box, {
        style: {
            display: "flex",
            alignItems: "center"
        },
        children: [
            modifiedStartIcon,
            /*#__PURE__*/ _jsx(Box, {
                style: {
                    marginLeft: "0.5em"
                },
                children: endIcon
            })
        ]
    }) : modifiedStartIcon;
    return /*#__PURE__*/ _jsx(StyledTag, _object_spread_props(_object_spread({}, props), {
        children: modifiedEndIcon
    }));
};
/* eslint-disable react/default-props-match-prop-types */ Tag.defaultProps = {
    variant: "primary",
    scale: scales.MD,
    outline: false
};
export default Tag;
